import userResources from "api/userResources";
import InputField from "components/fields/InputField";
import Logo from "components/Home/Logo/Logo";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import {
  FaGlobe,
  FaMailBulk,
  FaMapMarkerAlt,
  FaPhone,
  FaPhoneAlt,
} from "react-icons/fa";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import { toast } from "react-toastify";
import { logo3 } from "utils/images";
import { feedback } from "utils/images";
import { logo2 } from "utils/images";
import { logo1 } from "utils/images";

const contactInfo = [
  {
    icon: <FaMailBulk size={25} className="mr-2 text-[#bb8e25]" />,
    text: (
      <a
        href="mailto:Katariatravels@gmail.com?subject=Enquiry&body=Hello, I would like to inquire about your services."
        className="hover:text-blue-500 hover:underline"
      >
        Katariatravels@gmail.com
      </a>
    ),
  },
  {
    icon: <FaPhoneAlt size={25} className="mr-2 text-[#bb8e25]" />,
    text: (
      <a
        href="tel:+19056781200"
        className="hover:text-blue-500 hover:underline"
      >
        +1- 905-678-1200
      </a>
    ),
  },
  {
    icon: <FaGlobe size={25} className="mr-2 text-[#bb8e25]" />,
    text: (
      <a
        href="https://katariatravel.com/"
        className="hover:text-blue-500 hover:underline"
      >
        www.katariatravel.com
      </a>
    ),
  },
];
function Feedbackform() {
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm();
  // Register only the "required" rule for phone_number
  register("phone_number", {
    required: "Phone number is required.", // Error message if left empty
  });
  const [phoneNumber, setPhoneNumber] = useState("");

  const [rating, setRating] = useState(3);

  const onSubmit = async (data) => {
    console.log("Feedback Data:", { ...data, rating });

    // Show a loading toast
    const toastId = toast.loading("Submitting your feedback...");

    try {
      const response = await userResources.feedbackform({ ...data, rating });

      // Update the loading toast to success
      toast.update(toastId, {
        render: "Feedback submitted successfully!",
        type: "success",
        isLoading: false,
        autoClose: 3000, // Auto-close after 3 seconds
      });
      setPhoneNumber(null);
      setRating(3);
      reset();
    } catch (error) {
      // Update the loading toast to error
      toast.update(toastId, {
        render: "Something went wrong. Please try again!",
        type: "error",
        isLoading: false,
        autoClose: 3000, // Auto-close after 3 seconds
      });
    }
  };

  const handleStarClick = (index) => {
    setRating(index + 1); // Update the rating based on the clicked star
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-blue-100 to-[#bb8e25] p-4">
      <div className="grid w-full max-w-6xl grid-cols-1 items-start gap-4 rounded-lg bg-white p-8 shadow-lg lg:grid-cols-2">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="items-end gap-1.5 sm:grid md:grid-cols-2">
            <Logo logo1={logo1} logo2={logo2} logo3={logo3} />
            <h2 className="text-center  font-poppins text-2xl font-bold text-gray-900 ">
              Share your
              <br /> Journey with us!
            </h2>
            {/* Name Field */}
            <InputField
              label="Name"
              id="name"
              name="name"
              placeholder="Enter your name"
              register={register}
              rules={{
                required: "Name is required",
                minLength: {
                  value: 3,
                  message: "Name must be at least 3 characters long",
                },
              }}
              errorMessage={errors.name?.message}
            />

            {/* Email Field */}
            <InputField
              label="Email"
              id="email"
              name="email"
              type="email"
              placeholder="Enter your email"
              register={register}
              rules={{
                required: "Email is required",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Invalid email address",
                },
              }}
              errorMessage={errors.email?.message}
            />

            {/* Phone Number Field */}
            <div className="col-span-2">
              <label
                htmlFor="phone"
                className="my-2 block text-sm font-medium text-gray-900 dark:text-[#bb8e25]"
              >
                Phone Number
              </label>
              <div className="relative">
                <div className="flex">
                  <PhoneInputWithCountrySelect
                    defaultCountry="CA"
                    value={phoneNumber}
                    onChange={(value) => {
                      setPhoneNumber(value);
                      setValue("phone_number", value, { shouldValidate: true }); // Update the useForm state and validate
                    }}
                    placeholder="Enter Phone Number"
                    className="w-full rounded-md border p-2 text-lg focus:outline-none focus:ring-2 dark:!border-white/10"
                  />
                </div>
                <div className="absolute right-4 top-4">
                  <FaPhone />
                </div>
              </div>
              {errors.phone_number && (
                <span className="text-sm text-red-600">
                  {errors.phone_number.message}
                </span>
              )}
            </div>

            {/* Travel Experience Field */}
            <InputField
              label="Travel Experience"
              id="travel_experience"
              name="travel_experience"
              isTextArea
              placeholder="Share your travel experience"
              register={register}
              rules={{
                required: "Travel experience is required",
              }}
              errorMessage={errors.experience?.message}
              extra={"sm:col-span-2"}
            />
            {/* Star Rating Field */}
            <div>
              <label className="block text-sm font-medium text-gray-900">
                Rate Our Service
              </label>
              <div className="flex space-x-2">
                {[...Array(5)].map((_, index) => (
                  <span
                    key={index}
                    onClick={() => handleStarClick(index)}
                    className={`cursor-pointer text-2xl ${
                      index < rating ? "text-yellow-400" : "text-gray-300"
                    }`}
                  >
                    ★
                  </span>
                ))}
              </div>
              {rating === 0 && (
                <p className="mt-1 text-xs text-red-500">Rating is required</p>
              )}
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="w-full rounded-lg bg-[#bb8e25] px-4 py-2 font-semibold text-white transition duration-200 hover:bg-[#8f7029]"
            >
              Submit Feedback
            </button>
          </div>
        </form>

        {/* Image Section for Larger Screens */}
        <div className="flex flex-col justify-between gap-2">
          <div className="flex cursor-pointer flex-col items-center justify-center gap-2 text-gray-700 lg:hidden">
            <FaPhoneAlt size={25} className="mr-2 text-[#bb8e25]" />
            <p className="cursor-pointer text-center text-xs hover:text-blue-500 hover:underline">
              <a href="tel:+19056781200">+1- 905-678-1200</a>
            </p>
          </div>
          <div className="hidden  cursor-pointer flex-col items-center justify-center gap-2 text-gray-700 lg:flex">
            <FaMapMarkerAlt size={25} className="mr-2 text-[#bb8e25]" />
            <p className=" cursor-pointer text-center text-xs hover:text-blue-500 hover:underline">
              <a
                href="https://maps.app.goo.gl/GcR8NQwcP5cQvexn6"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-blue-500 hover:underline"
              >
                UNIT 12, 4550 EBENEZER RD BRAMPTON ONTARIO L6P 1H4, Canada
              </a>
            </p>
          </div>

          <div className="mb-4 grid grid-cols-2 gap-4 text-center lg:grid-cols-3 lg:text-left">
            {contactInfo.map((info, index) => (
              <div
                key={index}
                className={`mt-2 flex cursor-pointer flex-col items-center justify-center gap-2 text-gray-700 ${
                  index === 1 ? "hidden lg:flex" : ""
                }`}
              >
                {info.icon}
                <p className="cursor-pointer text-center text-xs hover:text-blue-500 hover:underline">
                  {info.text}
                </p>
              </div>
            ))}
          </div>
          <div className="flex cursor-pointer  flex-col items-center justify-center gap-2 text-gray-700 lg:hidden">
            <FaMapMarkerAlt size={25} className="mr-2 text-[#bb8e25]" />
            <p className=" cursor-pointer text-center text-xs hover:text-blue-500 hover:underline">
              <a
                href="https://maps.app.goo.gl/GcR8NQwcP5cQvexn6"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-blue-500 hover:underline"
              >
                UNIT 12, 4550 EBENEZER RD BRAMPTON ONTARIO L6P 1H4, Canada
              </a>
            </p>
          </div>
          <div>
            <img
              src={feedback}
              alt="Travel Enquiry"
              className="hidden h-auto w-full rounded-lg shadow-md lg:flex"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Feedbackform;
